<template>
  <v-container>
    <base-material-card color="secondary" class="mx-10" icon="mdi-send">
      <v-layout class="mx-10" row>
        <v-tabs v-model="tabs" background-color="transparent" color="secondary" slider-color="secondary">
          <v-tab id="tab-notify" v-if="notificheAttive" class="mr-3">
            <v-icon class="mr-2">mdi-bell</v-icon>
            {{ $t("send_notifications") }}
          </v-tab>
          <v-tab v-if="notificheAttive" id="tab-chat" class="mr-3">
            <v-icon class="mr-2">mdi-message-text-outline</v-icon>
            {{ $t("send_chat") }}
          </v-tab>
          <v-tab id="tab-email" class="mr-3">
            <v-icon class="mr-2">mdi-email-edit-outline</v-icon>
            {{ $t("send_emails") }}
          </v-tab>
        </v-tabs>
      </v-layout>

      <v-tabs-items v-model="tabs" class="transparent">
        <!-- NOTIFICHE -->
        <v-tab-item v-if="notificheAttive">
          <v-container>
            <v-row>
              <v-col class="text-center" cols="12">
                <v-radio-group class="text-center" row v-model="generalSend" :label="$t('send_from')">
                  <v-radio :label="$t('send_personal')" value="P"></v-radio>
                  <v-radio :label="$t('send_istitutional')" value="G"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="text-center">
                <v-select :items="dlNotifiche" v-model="destNotifiche" :label="$t('send_to')" />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="text-center">
                <v-text-field v-model="title" :label="$t('send_subject')" :rules="required"
                  hide-details="auto"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="text-center">
                <v-text-field v-model="messageText" :label="$t('message')" :rules="required"
                  hide-details="auto"></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" class="text-center">
                <v-btn @click="sendMessage('notify')" color="success">{{
                  $t("send_notify")
                }}</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>

        <!-- CHAT -->
        <v-tab-item v-if="notificheAttive">
          <v-container>
            <v-row>
              <v-col class="text-center" cols="12">
                <v-radio-group class="text-center" row v-model="generalSend" :label="$t('send_from')">
                  <v-radio :label="$t('send_personal')" value="P"></v-radio>
                  <v-radio :label="$t('send_istitutional')" value="G"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="text-center">
                <v-text-field v-model="messageText" :label="$t('message')" :rules="required"
                  hide-details="auto"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="text-center">
                <v-btn @click="sendMessage('chat')" color="success">{{
                  $t("write_in_chat")
                }}</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>

        <!-- EMAIL -->
        <v-tab-item>
          <v-container>
            <v-row>
              <v-col cols="12" class="text-center">
                <v-select :items="dlEmail" v-model="destEmail" :label="$t('send_to')" />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="text-center">
                <v-text-field v-model="title" :label="$t('send_subject')" :rules="required"
                  hide-details="auto"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <tiptap-vuetify :extensions="extensions" v-model="messageHtml"></tiptap-vuetify>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="text-center">
                <v-btn @click="sendMessage('email')" color="success">{{
                  $t("send_email")
                }}</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
      </v-tabs-items>
    </base-material-card>
    <v-dialog v-model="showSendLog">
      <v-card>
        <v-card-title class="text-right">
          <v-btn color="green darken-1" text @click="closeShowSendLog">{{
            $t("close")
          }}</v-btn>
        </v-card-title>
        <v-card-text>
          <v-list-item v-for="item in logs" :key="item.id">
            <v-list-item-avatar>
              <v-icon>mdi-send</v-icon>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>{{ item.msg }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History,
} from "tiptap-vuetify";
export default {
  name: "send-message",
  components: {
    TiptapVuetify,
  },
  data() {
    return {
      tabs: 0,
      type: null,
      showSendLog: false,
      generalSend: "G",
      title: null,
      destEmail: null,
      destNotifiche: null,
      messageText: null,
      messageHtml: null,
      notificheAttive: window.systemData.notification,
      extensions: [
        History,
        Blockquote,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        [
          Heading,
          {
            options: {
              levels: [1, 2, 3],
            },
          },
        ],
        Bold,
        Code,
        HorizontalRule,
        Paragraph,
        HardBreak,
      ],
      dlNotifiche: [],
      dlEmail: [],
      logs: [],
      required: [(value) => !!value || this.$t("required_field")],
    };
  },
  created() {
    let _ = this;
    this.chiamataAxios("GET", "/auth/notify/getDistributionList").then(
      (response) => {
        _.dlNotifiche = response.data.notifiche;
        _.dlEmail = response.data.email;
      }
    );
  },
  methods: {
    closeShowSendLog() {
      this.logs = null;
      this.showSendLog = false;
    },
    sendMessage: function (type) {
      let _ = this;
      let param = {
        type: type,
      };
      if (_.generalSend === "G") param.globalSender = true;
      else param.globalSender = false;

      if (type === "chat") {
        param.msg = _.messageText;
      }
      if (type === "email") {
        param.coda = _.destEmail;
        param.msg = _.messageHtml;
        param.title = _.title;
        param.globalSender = true;
      }
      if (type === "notify") {
        param.coda = _.destNotifiche;
        param.msg = _.messageText;
        param.title = _.title;
      }

      _.chiamataAxios("POST", "/auth/notify/sendNotify", { body: param }).then(
        (response) => {
          _.logs = response.data;
          _.showSendLog = true;
        }
      );
    },
  },
};
</script>
<style lang="scss">
.ck-content {
  height: 200px;
}
</style>
